import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';

import {
    START_QUERY_GROUP_COMPANY_REGISTER,
    QUERY_GROUP_COMPANY_REGISTER_SUCCESS,
    QUERY_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_QUERY_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    GROUP_COMPANY_REGISTER_QUERY_CHANGE_INPUT,
    SELECT_GROUP_COMPANY_REGISTER,
    OPEN_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
    RESET_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
    OPEN_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
    RESET_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
    ADD_OR_EDIT_GROUP_COMPANY_REGISTER_CHANGE_INPUT,
    START_SUBMIT_ADD_GROUP_COMPANY_REGISTER,
    SUBMIT_ADD_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_ADD_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_ADD_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    START_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER,
    SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_ACTION_STATUS,
    OPEN_DEL_GROUP_COMPANY_REGISTER_MODAL,
    RESET_DEL_GROUP_COMPANY_REGISTER_MODAL,
    START_SUBMIT_DEL_GROUP_COMPANY_REGISTER,
    SUBMIT_DEL_GROUP_COMPANY_REGISTER_SUCCESS,
    SUBMIT_DEL_GROUP_COMPANY_REGISTER_FAILURE,
    INIT_SUBMIT_DEL_GROUP_COMPANY_REGISTER_ACTION_STATUS,
} from './GroupCompanyRegisterConstants';

function startQueryGroupCompanyRegister() {
    return { type: START_QUERY_GROUP_COMPANY_REGISTER };
}

export function queryGroupCompanyRegister() {
    return function(dispatch) {
        dispatch(startQueryGroupCompanyRegister());
        httpClient
            .get(UrlConfig.QUERY_GROUP_COMPANY_REGISTER)
            .then(resp => dispatch(queryGroupCompanyRegisterSuccess(resp)))
            .catch(err => dispatch(queryGroupCompanyRegisterFailure(err)));
    };
}

function queryGroupCompanyRegisterSuccess(resp) {
    return {
        type: QUERY_GROUP_COMPANY_REGISTER_SUCCESS,
        payload: resp,
    };
}

function queryGroupCompanyRegisterFailure(err) {
    return {
        type: QUERY_GROUP_COMPANY_REGISTER_FAILURE,
        payload: err,
    };
}

export function initQueryGroupCompanyRegisterActionStatus() {
    return { type: INIT_QUERY_GROUP_COMPANY_REGISTER_ACTION_STATUS };
}

export function groupCompanyRegisterQueryChangeInput(input) {
    return {
        type: GROUP_COMPANY_REGISTER_QUERY_CHANGE_INPUT,
        payload: input,
    };
}

export function selectGroupCompanyRegister(array) {
    return {
        type: SELECT_GROUP_COMPANY_REGISTER,
        payload: array,
    };
}

export function openGroupCompanyRegisterDetailDialog(data) {
    return {
        type: OPEN_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
        payload: data,
    };
}

export function resetGroupCompanyRegisterDetailDialog() {
    return {
        type: RESET_GROUP_COMPANY_REGISTER_DETAIL_DIALOG,
    };
}

export function openAddOrEditGroupCompanyRegisterModal(mode, data) {
    return {
        type: OPEN_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
        payload: { mode, data },
    };
}

export function resetAddOrEditGroupCompanyRegisterModal() {
    return {
        type: RESET_ADD_OR_EDIT_GROUP_COMPANY_REGISTER_MODAL,
    };
}

export function addOrEditGroupCompanyRegisterChangeInput(input) {
    return {
        type: ADD_OR_EDIT_GROUP_COMPANY_REGISTER_CHANGE_INPUT,
        payload: input,
    };
}

function startSubmitAddGroupCompanyRegister() {
    return { type: START_SUBMIT_ADD_GROUP_COMPANY_REGISTER };
}

export function submitAddGroupCompanyRegister(data) {
    return function(dispatch) {
        dispatch(startSubmitAddGroupCompanyRegister());
        httpClient
            .post(UrlConfig.SUBMIT_ADD_GROUP_COMPANY_REGISTER, data)
            .then(resp => dispatch(submitAddGroupCompanyRegisterSuccess(resp)))
            .catch(err => dispatch(submitAddGroupCompanyRegisterFailure(err)));
    };
}

function submitAddGroupCompanyRegisterSuccess(resp) {
    return {
        type: SUBMIT_ADD_GROUP_COMPANY_REGISTER_SUCCESS,
        payload: resp,
    };
}

function submitAddGroupCompanyRegisterFailure(err) {
    return {
        type: SUBMIT_ADD_GROUP_COMPANY_REGISTER_FAILURE,
        payload: err,
    };
}

export function initSubmitAddGroupCompanyRegisterActionStatus() {
    return { type: INIT_SUBMIT_ADD_GROUP_COMPANY_REGISTER_ACTION_STATUS };
}

function startSubmitUpdateGroupCompanyRegister() {
    return { type: START_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER };
}

export function submitUpdateGroupCompanyRegister(data) {
    return function(dispatch) {
        dispatch(startSubmitUpdateGroupCompanyRegister());
        httpClient
            .post(UrlConfig.SUBMIT_UPDATE_GROUP_COMPANY_REGISTER, data)
            .then(resp => dispatch(submitUpdateGroupCompanyRegisterSuccess(resp)))
            .catch(err => dispatch(submitUpdateGroupCompanyRegisterFailure(err)));
    };
}

function submitUpdateGroupCompanyRegisterSuccess(resp) {
    return {
        type: SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_SUCCESS,
        payload: resp,
    };
}

function submitUpdateGroupCompanyRegisterFailure(err) {
    return {
        type: SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_FAILURE,
        payload: err,
    };
}

export function initSubmitUpdateGroupCompanyRegisterActionStatus() {
    return { type: INIT_SUBMIT_UPDATE_GROUP_COMPANY_REGISTER_ACTION_STATUS };
}

export function openDelGroupCompanyRegisterModal(data) {
    return {
        type: OPEN_DEL_GROUP_COMPANY_REGISTER_MODAL,
        payload: data,
    };
}

export function resetDelGroupCompanyRegisterModal() {
    return {
        type: RESET_DEL_GROUP_COMPANY_REGISTER_MODAL,
    };
}

function startSubmitDelGroupCompanyRegister() {
    return { type: START_SUBMIT_DEL_GROUP_COMPANY_REGISTER };
}

export function submitDelGroupCompanyRegister(data) {
    return function(dispatch) {
        dispatch(startSubmitDelGroupCompanyRegister());
        httpClient
            .post(UrlConfig.SUBMIT_DEL_GROUP_COMPANY_REGISTER, data)
            .then(resp => dispatch(submitDelGroupCompanyRegisterSuccess(resp)))
            .catch(err => dispatch(submitDelGroupCompanyRegisterFailure(err)));
    };
}

function submitDelGroupCompanyRegisterSuccess(resp) {
    return {
        type: SUBMIT_DEL_GROUP_COMPANY_REGISTER_SUCCESS,
        payload: resp,
    };
}

function submitDelGroupCompanyRegisterFailure(err) {
    return {
        type: SUBMIT_DEL_GROUP_COMPANY_REGISTER_FAILURE,
        payload: err,
    };
}

export function initSubmitDelGroupCompanyRegisterActionStatus() {
    return { type: INIT_SUBMIT_DEL_GROUP_COMPANY_REGISTER_ACTION_STATUS };
}
